import { motion } from 'framer-motion';
import { LuCheck } from 'react-icons/lu';
import { Card, Pill } from '../../../design-system/components';
import { cx } from '../../../design-system/components/cx';
import LinkButton from './LinkButton';

interface PricingCardProps {
  name: string;
  price: string;
  period: string;
  description: string;
  features: string[];
  cta: string;
  ctaLink: string;
  highlighted?: boolean;
  originalPrice?: string;
  index: number;
}

/**
 * One plan on a Card; the highlighted plan has the orange border and the
 * primary Button. Every plan is a white Card: the band behind them is warm,
 * so a warm card there would lose its lift.
 */
export default function PricingCard({
  name,
  price,
  period,
  description,
  features,
  cta,
  ctaLink,
  highlighted = false,
  originalPrice,
  index,
}: PricingCardProps) {
  return (
    <motion.div
      className="ee-landing-cell"
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.12 }}
    >
      <Card
        padding="lg"
        className={cx('ee-landing-plan', highlighted && 'ee-landing-plan--featured')}
      >
        {highlighted ? (
          <Pill variant="new" className="ee-landing-plan__badge">
            Most Popular
          </Pill>
        ) : null}
        <h3 className="ee-landing-plan__name">{name}</h3>
        <p className="ee-landing-plan__desc">{description}</p>
        <div className="ee-landing-plan__price-row">
          {originalPrice ? <span className="ee-landing-plan__was">{originalPrice}</span> : null}
          <span className="ee-landing-plan__price">{price}</span>
          <span className="ee-landing-plan__period">{period}</span>
        </div>
        {features.length > 0 ? (
          <ul className="ee-landing-plan__features">
            {features.map((feature) => (
              <li key={feature} className="ee-landing-plan__feature">
                <LuCheck className="ee-landing-compare__yes" aria-hidden="true" focusable="false" />
                {feature}
              </li>
            ))}
          </ul>
        ) : (
          <div className="ee-landing-plan__spacer" />
        )}
        <LinkButton
          to={ctaLink}
          variant={highlighted ? 'primary' : 'secondary'}
          fullWidth
          className="ee-landing-plan__cta"
        >
          {cta}
        </LinkButton>
      </Card>
    </motion.div>
  );
}
